import { useState } from "react"
import { Stack, TextField } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"

const useStyles = makeStyles()(() => ({
    content: {
        padding: "0 1.5rem 1.5rem",
    },
}))

type Props = Readonly<{
    open: boolean
    isNew: boolean
    initialName: string
    onSave: (name: string) => void
    onClose: () => void
}>

export function CategoryNameDialog({ open, isNew, initialName, onSave, onClose }: Props) {
    const { classes } = useStyles()

    const [name, setName] = useState(initialName)
    const [saveAttempted, setSaveAttempted] = useState(false)

    const trimmedName = name.trim()

    const handleSave = () => {
        setSaveAttempted(true)
        if (trimmedName) onSave(trimmedName)
    }

    return (
        <LocalizedStrict
            id={
                isNew
                    ? "merchant-menu-templates-category-dialog-add-title"
                    : "merchant-menu-templates-category-dialog-edit-title"
            }
            attrs={{ dialogTitle: true }}
        >
            <StandardDialog
                open={open}
                onClose={onClose}
                maxWidthProp="xs"
                disableMobileFullScreen
                dialogTitle="Add category"
            >
                <Stack spacing="1.5rem" className={classes.content}>
                    <LocalizedStrict
                        id="merchant-menu-templates-category-dialog-name-field"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <TextField
                            label="Category name"
                            placeholder="e.g. Warm dishes"
                            value={name}
                            autoFocus
                            fullWidth
                            error={saveAttempted && !trimmedName}
                            onChange={(event) => setName(event.target.value)}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") handleSave()
                            }}
                        />
                    </LocalizedStrict>
                    <Stack direction="row" spacing="1rem">
                        <LocalizedStrict id="merchant-menu-templates-category-dialog-cancel-button">
                            <StandardButton variant="outlined" onClick={onClose}>
                                Cancel
                            </StandardButton>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-menu-templates-category-dialog-save-button">
                            <StandardButton color="black" disabled={saveAttempted && !trimmedName} onClick={handleSave}>
                                Save
                            </StandardButton>
                        </LocalizedStrict>
                    </Stack>
                </Stack>
            </StandardDialog>
        </LocalizedStrict>
    )
}
